import HTTP from "../../http";

const CART_ENDPOINT = "/carts";
const UPDATE_CART_ENDPOINT = "/";

export async function updateCart(cart) {
  return await HTTP.put(
    CART_ENDPOINT + UPDATE_CART_ENDPOINT,
    { cart },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
